import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import DatePicker from 'on_web/components/shared/DatePicker/DatePicker';

import SectionTitle from 'on_web/components/shared/Common/SectionTitle';
import SvgAnimation from 'on_web/components/shared/Common/SvgAnimation/SvgAnimation';
import PointSelection from 'on_web/components/shared/Common/PointSelection/PointSelection';
import CheckboxList from 'on_web/components/shared/Common/CheckboxList/CheckboxList';
import RadioList from 'on_web/components/shared/Common/RadioList/RadioList';
import Text from 'on_web/components/shared/Common/Text';
import TextField from 'on_web/components/shared/TextField/TextField';
import SelectableIconRadioList from 'on_web/components/shared/SelectableIconRadioList/SelectableIconRadioList';
import SelectableIconList from 'on_web/components/shared/SelectableIconList/SelectableIconList';
import NumericalInput from 'on_web/components/shared/NumericalInput/NumericalInput';

export default function Question(props) {
  const [selectedPoint, setSelectedPoint] = useState(
    props.pointSelection != null ? props.pointSelection.selectedIx : undefined
  );
  const [selectedMetadataValue, setSelectedMetadataValue] = useState(undefined);

  useEffect(() => {
    let checkboxCheckedValues =
      props.checkboxSelection &&
      props.checkboxSelection.items &&
      props.checkboxSelection.items
        .filter(t => t.checked === true)
        .map(t => t.value);

    let checkboxWithIconCheckedValues =
      props.checkboxSelectionWithIcon &&
      props.checkboxSelectionWithIcon.items &&
      props.checkboxSelectionWithIcon.items
        .filter(t => t.checked === true)
        .map(t => t.value);

    let radioCheckedValues =
      props.radioSelection &&
      props.radioSelection.items &&
      props.radioSelection.items
        .filter(t => t.checked === true)
        .map(t => t.value);

    if (
      checkboxCheckedValues &&
      checkboxCheckedValues.includes(
        props.checkboxSelection.showMetaDataInputFor
      )
    ) {
      setSelectedMetadataValue(props.checkboxSelection.showMetaDataInputFor);
    }

    if (
      checkboxWithIconCheckedValues &&
      checkboxWithIconCheckedValues.includes(
        props.checkboxSelectionWithIcon.showMetaDataInputFor
      )
    ) {
      setSelectedMetadataValue(
        props.checkboxSelectionWithIcon.showMetaDataInputFor
      );
    }

    if (
      radioCheckedValues &&
      radioCheckedValues.includes(props.radioSelection.showMetaDataInputFor)
    ) {
      setSelectedMetadataValue(props.radioSelection.showMetaDataInputFor);
    }
  });

  const onAnswer = (val, checked) => {
    if (isPointSelection()) {
      setSelectedPoint(val);
    }

    if (
      (props.radioSelection &&
        props.radioSelection.showMetaDataInputFor &&
        checked === true) ||
      (props.checkboxSelection &&
        props.checkboxSelection.showMetaDataInputFor &&
        checked === true) ||
      (props.checkboxSelectionWithIcon &&
        props.checkboxSelectionWithIcon.showMetaDataInputFor &&
        checked === true)
    ) {
      setSelectedMetadataValue(val);
    } else {
      setSelectedMetadataValue(undefined);
    }

    if (props.onAnswer) {
      props.onAnswer(val, checked);
    }
  };

  const onAnswerMetadata = val => {
    if (props.onAnswerMetadata) {
      props.onAnswerMetadata(val);
    }
  };

  const isPointSelection = () => {
    return (
      props.pointSelection &&
      props.pointSelection.answers &&
      props.pointSelection.answers.length
    );
  };

  return (
    <React.Fragment>
      {props.sectionTitle && <SectionTitle text={props.sectionTitle} />}

      {props.instructionAbove && (
        <Box
          px={{ xs: 2.5, sm: 3, md: 4 }}
          pt={{ xs: 2.5, sm: 3, md: 4 }}
          style={{
            borderTop:
              props.showTopBorder === true ? '1px Solid #ececec' : 'none',
          }}
        >
          <Text variant="caption" display="block" gutterBottom>
            {props.instructionAbove}
          </Text>
        </Box>
      )}

      {props.prefixControls &&
        props.prefixControls.map((ctrl, ix) => {
          return (
            <div key={ix} style={{ marginTop: '15px' }}>
              {ctrl}
            </div>
          );
        })}

      {props.animationImages && props.animationImages.length > 0 && (
        <Box
          p={{ xs: 2.5, sm: 3, md: 4 }}
          mr={{ xs: 2.5 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <SvgAnimation
            images={props.animationImages}
            selectedImageIndex={
              selectedPoint != null
                ? selectedPoint
                : Math.floor(props.animationImages.length / 2)
            }
          />
        </Box>
      )}

      {props.pointSelectionTitle && (
        <Box
          pt={{ xs: 2.5, sm: 3, md: 4 }}
          px={{ xs: 2.5, sm: 3, md: 4 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Text variant="h5">{props.pointSelectionTitle}</Text>
        </Box>
      )}

      {isPointSelection() > 0 && (
        <Box mt={{ xs: 2.5 }} mb={{ xs: 2.5 }}>
          <PointSelection
            texts={props.pointSelection.answers}
            color={props.pointSelection.color}
            onSelect={ix => onAnswer(ix)}
            selectedDot={props.pointSelection.selectedIx}
            textOnBothSides={props.pointSelection.textOnBothSides}
            tag={props.pointSelection.tag}
          />
        </Box>
      )}

      {props.checkboxSelection &&
        props.checkboxSelection.items &&
        props.checkboxSelection.items.length > 0 && (
          <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
            <CheckboxList
              items={props.checkboxSelection.items}
              dividerBelowItem={props.dividerBelowItem}
              onCheckboxChange={(val, checked) => onAnswer(val, checked)}
              deselectAllValue={props.deselectAllValue}
              disableAllValue={props.disableAllValue}
              additionalDisableAndDeselectValues={
                props.additionalDisableAndDeselectValues
              }
              excludeFromDeselectValues={props.excludeFromDeselectValues}
              twoColumns={props.checkboxSelection.twoColumns}
            />
            {props.checkboxSelection.showMetaDataInputFor &&
              selectedMetadataValue &&
              selectedMetadataValue ===
                props.checkboxSelection.showMetaDataInputFor && (
                <TextField
                  fullWidth
                  onChange={e => onAnswerMetadata(e.target.value)}
                  value={props.metadataValue}
                  placeholder={props.placeholder}
                />
              )}
          </Box>
        )}

      {props.checkboxSelectionWithIcon &&
        props.checkboxSelectionWithIcon.items &&
        props.checkboxSelectionWithIcon.items.length > 0 && (
          <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
            <SelectableIconList
              twoColumns={props.checkboxSelectionWithIcon.twoColumns}
              items={props.checkboxSelectionWithIcon.items}
              labelFontSize={16}
              labelPlacement="end"
              onCheckboxChange={(val, checked) => onAnswer(val, checked)}
              metadataValue={
                props.checkboxSelectionWithIcon.showMetaDataInputFor
              }
              showMetadata={
                props.checkboxSelectionWithIcon.showMetaDataInputFor &&
                selectedMetadataValue &&
                selectedMetadataValue ===
                  props.checkboxSelectionWithIcon.showMetaDataInputFor
              }
              value={props.metadataValue}
              onAnswerMetadata={props.onAnswerMetadata}
              placeholder={props.placeholder}
            />
          </Box>
        )}

      {props.radioSelection &&
        props.radioSelection.items &&
        props.radioSelection.items.length > 0 && (
          <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
            <RadioList
              items={props.radioSelection.items}
              onRadioChange={val => onAnswer(val)}
              twoColumns={props.radioSelection.twoColumns}
            />
            {props.radioSelection.showMetaDataInputFor &&
              selectedMetadataValue &&
              selectedMetadataValue ===
                props.radioSelection.showMetaDataInputFor && (
                <TextField
                  fullwidth
                  onChange={e => onAnswerMetadata(e.target.value)}
                  value={props.metadataValue}
                  placeholder={props.placeholder}
                />
              )}
          </Box>
        )}

      {props.radioSelectionWithIcon &&
        props.radioSelectionWithIcon.items &&
        props.radioSelectionWithIcon.items.length > 0 && (
          <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
            <SelectableIconRadioList
              twoColumns={props.radioSelectionWithIcon.twoColumns}
              items={props.radioSelectionWithIcon.items}
              labelFontSize={16}
              labelPlacement="end"
              onRadioChange={val => onAnswer(val)}
            />
          </Box>
        )}

      {props.numericalInputValue != null && (
        <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
          <NumericalInput
            value={
              props.numericalInputValue < props.numericalInputValueMin
                ? undefined
                : props.numericalInputValue
            }
            onChange={val => onAnswer(val)}
            inputProps={{
              step: 1,
              min: props.numericalInputValueMin,
              max: props.numericalInputValueMax
                ? props.numericalInputValueMax
                : 100,
              type: 'number',
              'aria-labelledby': 'input-slider',
            }}
            numericalInputValueValidationMsg={
              props.numericalInputValueValidationMsg
            }
            autoFocus={props.autoFocus}
          />
        </Box>
      )}

      {props.textInput === true && (
        <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
          <TextField
            value={props.textValue}
            fullWidth
            onChange={e => onAnswer(e.target.value)}
            autoFocus={props.autoFocus}
          />
        </Box>
      )}

      {props.monthInput === true && (
        <Box p={{ xs: 2.5, sm: 3, md: 4 }}>
          <DatePicker
            minDate={props.minDate}
            maxDate={props.maxDate}
            onChange={e => onAnswer(e)}
            value={props.monthValue}
          />
        </Box>
      )}
    </React.Fragment>
  );
}

Question.propTypes = {
  // If it isn't undefined, SectionTitle will be displayed containing the specified value.
  // There are questions which don't have section title and that's why this isn't required.
  sectionTitle: PropTypes.string,
  // Text above the answers, providing instructions
  instructionAbove: PropTypes.string,
  // Array of images which are displayed or hidden based on answer selection.
  animationImages: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    })
  ),
  // If answers are given through point selection, defines selecatable points
  pointSelection: PropTypes.shape({
    color: PropTypes.string,
    selectedIx: PropTypes.number,
    answers: PropTypes.arrayOf(PropTypes.string),
    textOnBothSides: PropTypes.bool,
  }),
  // If answers are given through checkbox selection, defines checkboxes
  checkboxSelection: PropTypes.shape({
    twoColumns: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        checked: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
  }),
  // If answers are given through checbox selection with icons, defines checkboxes
  checkboxSelectionWithIcon: PropTypes.shape({
    twoColumns: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.element,
        checked: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
    showMetaDataInputFor: PropTypes.string,
  }),
  // display divider below an item in the list
  dividerBelowItem: PropTypes.number,
  // If answers are given through radio buttons, defines radio buttons
  radioSelection: PropTypes.shape({
    twoColumns: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        checked: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
    showMetaDataInputFor: PropTypes.string,
  }),
  // If answers are given through radio buttons with icons, defines radio buttons
  radioSelectionWithIcon: PropTypes.shape({
    twoColumns: PropTypes.bool,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.element,
        checked: PropTypes.bool,
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
  }),
  // Callback when answer is selected
  onAnswer: PropTypes.func.isRequired,
  // If set to true, question is Text input
  monthInput: PropTypes.bool,
  // If set to true, question is DatePicker input
  textInput: PropTypes.bool,
  // If textInput is true, defines the value for text input
  textValue: PropTypes.string,
  // If set, question is numberical input
  numericalInputValue: PropTypes.number,
  /**
   * Min value for numerical input
   */
  numericalInputValueMin: PropTypes.number,
  /**
   * If set to true, sets focus to the input control
   */
  autoFocus: PropTypes.bool,
};
